import {HttpClient}                                    from '@angular/common/http';
import {Component, OnInit, ViewChild}                  from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef}                       from '@angular/material/dialog';
import {MatPaginator, PageEvent}                       from '@angular/material/paginator';
import {MatSnackBar}                                   from '@angular/material/snack-bar';
import {MatTableDataSource}                            from '@angular/material/table';
import {ActivatedRoute, Router, UrlTree}               from '@angular/router';
import {Manufacturer}                                  from '@src/app/admin/manufacturers/models/manufacturer.model';
import {ManufacturerService}                           from '@src/app/admin/manufacturers/services/manufacturer.service';
import {ProductManufacturer}                           from '@src/app/admin/products/models/product.model';
import {Breadcrumb}                                    from '@src/app/shared/models/breadcrumb.model';
import {Button}                                        from '@src/app/shared/models/button.model';
import {ApiService}                                    from '@src/app/shared/services/api.service';
import {environment}                                   from '@src/environments/environment';
import {query}                                         from 'js-query-builder';
import moment                                          from 'moment';
import {AdditionalPriceTierModalComponent}             from '../additional-price-tier-modal/additional-price-tier-modal.component';
import {EditPriceTierModalComponent}                   from '../edit-price-tier-modal/edit-price-tier-modal.component';
import {PriceUploadModalComponent}                     from '../price-upload-modal/price-upload-modal.component';
import {DeletePriceTierModalComponent}                 from '../delete-price-tier-modal/delete-price-tier-modal.component';
import {DialogComponent}                               from '@src/app/shared/components/dialog/dialog.component';

@Component({
    standalone: false,
    selector: 'app-pricing-view',
    templateUrl: './pricing-view.component.html',
    styleUrls: ['./pricing-view.component.css']
})
export class PricingViewComponent implements OnInit
{
    @ViewChild(MatPaginator) public paginator!: MatPaginator;
    public actionType: 'add' | 'edit' = 'add';
    public productManufacturer: ProductManufacturer;

    public manufacturers: Manufacturer[];
    public isDynamicallyPriced: boolean = false;
    public loading: boolean = false;
    public manufacturerForm: FormGroup;
    public priceChanges: any[] = [];
    public pageTitle: string = 'Add Pricing';
    public breadcrumbs: Breadcrumb[] = [];
    public buttons: Button[] = [];
    public currentDate: Date = new Date();
    public dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
    public displayColumns = ['tier', 'operative_cost', 'subcontractor_cost', 'material_cost', 'sell_price', 'effective_from', 'effective_to', 'action'];
    public totalRows: number = 0;
    public pageSize: number = 10;
    public currentPage: number = 0;
    public pageSizeOptions: number[] = [5, 10, 25, 100];

    public get pricingTiersArray()
    {
        return this.manufacturerForm.controls['pricing_tiers'] as FormArray;
    }

    constructor(
        public snackBar: MatSnackBar,
        private manufacturerService: ManufacturerService,
        private apiService: ApiService,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private httpClient: HttpClient,
        public dialog: MatDialog
    )
    {
        this.breadcrumbs = [
            {
                title: 'Home',
                url: '/app/',
                active: false
            },
            {
                title: 'Products',
                active: false,
                url: '/app/products/',
            },
            {
                title: 'Edit Pricing',
                active: true,
            },
        ];

        this.buttons = [
            {
                type: 'button',
                material: 'flat',
                color: 'primary',
                title: 'Save Product',
                permission: 'add_products',
                callback: () => {
                    this.onSubmit();
                }
            }
        ];

        this.manufacturerForm = this.fb.group({
            product_id: [null, Validators.required],
            manufacturer_id: [null, Validators.required],
            effective_from: [null],
            tier: [0, [Validators.required, Validators.min(0)]],
            operative_cost: [0, [Validators.required, Validators.min(0)]],
            subcontractor_cost: [0, [Validators.required, Validators.min(0)]],
            material_cost: [0, [Validators.required, Validators.min(0)]],
            sell_price: [0, [Validators.required, Validators.min(0)]],
            pricing_tiers: this.fb.array([])
        });

        this.activatedRoute.params.subscribe(params => {

            if (params['price_id'] != 'create') {
                this.actionType = 'edit';

                this.apiService.get(`products/manufacturer/${params['price_id']}`).subscribe(
                    response => {
                        this.productManufacturer = response.data;

                        this.isDynamicallyPriced = this.productManufacturer?.product.measure.id <= 5;

                        this.isDynamicallyPriced ? this.buttons = [] : this.buttons = [
                            {
                                type: 'button',
                                material: 'flat',
                                color: 'primary',
                                title: 'Save Product',
                                permission: 'add_products',
                                callback: () => {
                                    this.onSubmit();
                                }
                            }
                        ];

                        this.pageTitle = `Edit Pricing: ${this.productManufacturer?.manufacturer.name}`;

                        this.breadcrumbs = [
                            {
                                title: 'Home',
                                url: '/app/',
                                active: false
                            },
                            {
                                title: 'Products',
                                active: false,
                                url: '/app/products/',
                            },
                            {
                                title: `${this.productManufacturer?.product.name}`,
                                active: false,
                                url: '/app/products/edit/' + params['id'],
                            },
                            {
                                title: `Edit Pricing: ${this.productManufacturer?.manufacturer.name}`,
                                active: true,
                            },
                        ];

                        this.manufacturerForm = this.fb.group({
                            product_id: [params['id'], Validators.required],
                            manufacturer_id: [{
                                value: this.productManufacturer?.manufacturer.id,
                                disabled: true
                            }, Validators.required],
                            effective_from: [new Date(this.productManufacturer?.default_price?.effective_from)],
                            tier: [this.productManufacturer?.default_price?.tier, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                            operative_cost: [this.productManufacturer?.default_price?.operative_cost, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                            subcontractor_cost: [this.productManufacturer?.default_price?.subcontractor_cost, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                            material_cost: [this.productManufacturer?.default_price?.material_cost, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                            sell_price: [this.productManufacturer?.default_price?.sell_price, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                            pricing_tiers: this.fb.array([])
                        });

                        this.loadPrices();
                    },
                    error => this.apiService.handleError(error)
                );
            } else {
                this.apiService.get(`products/${params['id']}`).subscribe(
                    response => this.isDynamicallyPriced = response.data.measure.id <= 5,
                    error => this.apiService.handleError(error)
                );

                this.manufacturerForm = this.fb.group({
                    product_id: [params['id'], Validators.required],
                    manufacturer_id: ['', Validators.required],
                    effective_from: [''],
                    tier: [0, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                    operative_cost: [0, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                    subcontractor_cost: [0, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                    material_cost: [0, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                    sell_price: [0, !this.isDynamicallyPriced ? [Validators.required, Validators.min(0)] : Validators.min(0)],
                    pricing_tiers: this.fb.array([])
                });
            }

        });
    }

    public ngOnInit(): void
    {
        // NOTE: Ideally this should be filters with a where not in or something liek that?
        this.manufacturerService.GetManufacturers(0, 0, true).subscribe(
            response => this.manufacturers = response.data,
            response => this.manufacturerService.ErrorHandler(response)
        );
    }

    public loadPrices(): void
    {
        const url = query(`products/prices`)
            .filter('manufacturer_product_id', this.productManufacturer?.id)
            .filter('by_date', 'current')
            .fields({
                manufacturer_prices: ['id', 'manufacturer_product_id', 'tier', 'operative_cost', 'subcontractor_cost', 'material_cost', 'sell_price', 'effective_from', 'effective_to', 'created_at', 'updated_at']
            })
            .param('page[number]', this?.currentPage + 1)
            .param('page[size]', this?.pageSize)
            .sort('tier')
            .build();

        this.apiService.get(url).subscribe(
            response => {
                const responseData = this.isDynamicallyPriced ? response.data : response.data.filter(c => c.tier != '0.00');

                this.pricingTiersArray.clear();

                this.dataSource = new MatTableDataSource(responseData);
                this.paginator.pageIndex = this.currentPage;
                this.totalRows = response.meta.total;

                this.priceChanges.forEach((priceChange) => {
                    const dataIndex = this.dataSource.data.findIndex(item => item.id === priceChange.id);

                    if (dataIndex !== -1) {
                        this.dataSource.data[dataIndex] = priceChange;
                    }
                });

                this.dataSource._updateChangeSubscription();
            },
            error => this.apiService.handleError(error)
        );
    }

    public onSubmit(): void
    {
        if (this.manufacturerForm.valid) {
            const formData = this.manufacturerForm.getRawValue();
            formData.effective_from = moment(this.manufacturerForm.get('effective_from')?.value).format('YYYY-MM-DD');

            if (this.actionType === 'edit') {
                // Update
                this.apiService.update('products/prices', this.productManufacturer?.default_price?.id, formData).subscribe(
                    response => {
                        this.successCall(response);
                    },
                    error => {
                        this.errorCall(error);
                    }
                );
            } else {
                // Create
                this.apiService.create('products/prices', formData).subscribe(
                    response => {
                        this.successCall(response);
                    },
                    error => {
                        this.errorCall(error);
                    });
            }
        } else {
            this.snackBar.open('Please fill all required fields', 'Close', {
                duration: 3000,
                panelClass: ['error-snackbar']
            });
        }
    }

    public editPriceTier(priceTier: any): void
    {
        // Open your modal here and pass the priceTier data
        let priceForm = this.dialog.open(EditPriceTierModalComponent, {
            width: '50%',
            data: {
                priceTier: {
                    ...priceTier,
                    manufacturer_id: this.productManufacturer?.manufacturer.id,
                    product_id: this.productManufacturer?.product.id,
                },
                type: 'edit'
            }
        });

        priceForm.afterClosed().subscribe(result => {
            if (result) {
                this.loadPrices();
            }
        });
    }

    public addPriceTier(): void
    {
        let priceForm = this.dialog.open(EditPriceTierModalComponent, {
            width: '50%',
            data: {
                priceTier: {
                    manufacturer_id: this.productManufacturer?.manufacturer.id,
                    product_id: this.productManufacturer?.product.id,
                },
                type: 'add'
            }
        });

        priceForm.afterClosed().subscribe(result => {
            if (result) {
                this.loadPrices();
            }
        });
    }

    public deletePriceTier(priceTier: any): void
    {
        let removalForm = this.dialog.open(DeletePriceTierModalComponent, {
            width: '40%',
            data: {
                priceTier: priceTier,
            }
        });

        removalForm.afterClosed().subscribe(result => {
            if (result) {
                this.loadPrices();
            }
        });
    }

    public confirmArchivePriceTier(priceTier: any): void
    {
        const confirmDialogRef = this.dialog.open(DialogComponent, {
            data: {
                title: 'Archive Pricing Tier',
                message: 'Are you sure you want to archive this pricing tier? You can\'t undo this action.',
                type: 'danger-outline',
                confirmButtonLabel: 'Archive'
            }
        });

        confirmDialogRef.afterClosed().subscribe(confirm => {
            if (confirm) {
                this.deletePriceTier(priceTier);
            }
        });
    }

    public openAdditionalPriceModal(): void
    {
        let priceForm = this.dialog.open(AdditionalPriceTierModalComponent, {
            width: '80%',
            data: {
                productManufacturer: this.productManufacturer,
                isDynamicallyPriced: this.isDynamicallyPriced,
            }
        });
    }

    public downloadTemplate()
    {
        this.httpClient.get(`${environment.apiUrl}/prices-export/${this.productManufacturer.id}/download`, {
            responseType: 'blob',
            observe: 'response'
        }).subscribe((response) => {
            const data = response.body;
            let filename = 'price-template.xlsx'; // Default filename

            // Try to get filename from Content-Disposition header
            const contentDisposition = response.headers.get('Content-Disposition');
            if (contentDisposition) {
                const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }

            let downloadURL = window.URL.createObjectURL(data);
            let link = document.createElement('a');

            link.href = downloadURL;
            link.download = filename;
            link.click();
        });
    }

    public uploadPrices(): void
    {
        const priceUploadDialog: MatDialogRef<PriceUploadModalComponent> = this.dialog.open(PriceUploadModalComponent, {
            width: '65%',
            panelClass: 'mobile-width',
            disableClose: true,
            data: {productManufacturer: this.productManufacturer}
        });

        priceUploadDialog.afterClosed().subscribe((data): void => {
            this.loadPrices();
        });
    }

    public pageChanged(event: PageEvent): void
    {
        this.pageSize = event.pageSize;
        this.currentPage = event.pageIndex;
        this.loadPrices();
    }

    private successCall(response: any): void
    {
        this.snackBar.open('Price tier saved successfully', 'Close', {
            duration: 3000,
            panelClass: ['success-snackbar']
        });

        let redirectUrl: string | UrlTree;

        if (this.actionType === 'add') {
            this.actionType = 'edit';
            redirectUrl = `/app/products/edit/${response.data?.product.id}/pricing/${response.data.manufacturer_product_id}`;
        } else {
            redirectUrl = `/app/products/edit/${response.data?.product.id}`;
        }

        this.router.navigateByUrl(redirectUrl);
    }

    private errorCall(error: any): void
    {
        this.apiService.handleError(error);
        this.snackBar.open('Failed to save price tier', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
        });
    }
}
